var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cloud-dialog",
    {
      staticClass: "complete-account-type",
      attrs: { "append-in-body": _vm.appendInBody, area: [1134, 640] },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c("div", { staticClass: "select-account-type" }, [
        _c(
          "p",
          {
            staticClass: "title",
            attrs: { title: _vm.$t("choose_service_type") },
          },
          [_vm._v(_vm._s(_vm.$t("choose_service_type")))]
        ),
        _c(
          "p",
          {
            staticClass: "text",
            attrs: { title: _vm.$t("choose_id_explain") },
          },
          [_vm._v(_vm._s(_vm.$t("choose_id_explain")))]
        ),
        _vm.showClose
          ? _c("i", {
              staticClass: "h-icon-close close-style",
              on: { click: _vm.cancelChoose },
            })
          : _vm._e(),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c(
              "el-scrollbar",
              { attrs: { "wrap-class": "content-scrollbar" } },
              _vm._l(_vm.accountTypeShow, function (item) {
                return _c(
                  "div",
                  {
                    key: item.key,
                    staticClass: "type-card",
                    class: {
                      "type-card-select": item.key === _vm.selected,
                      disabled: item.cantChoose,
                    },
                    style: {
                      cursor: item.cantChoose ? "not-allowed" : "pointer",
                    },
                    on: {
                      click: function ($event) {
                        !item.cantChoose && _vm.selectType(item.key)
                      },
                    },
                  },
                  [
                    item.cantChoose
                      ? _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom",
                              trigger: "hover",
                              content: _vm.$t(
                                "HPP-web_distributor_cannot_choose_msg"
                              ),
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-direction": "column",
                                  "align-items": "center",
                                },
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [
                                _c("i", {
                                  staticClass: "icon",
                                  class: `${item.icon}${
                                    item.key === _vm.selected ? "_hover" : ""
                                  } ${
                                    item.descTip && item.key === _vm.selected
                                      ? "icon-desc-tip"
                                      : ""
                                  }`,
                                }),
                                _c(
                                  "p",
                                  {
                                    staticClass: "name",
                                    attrs: { title: _vm.$t(item.label) },
                                  },
                                  [_vm._v(_vm._s(_vm.$t(item.label)))]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticClass: "desc",
                                    attrs: {
                                      title:
                                        _vm.$t(item.desc) +
                                        " " +
                                        _vm.$t(item.descTip),
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t(item.desc))),
                                    ]),
                                    item.descTip && item.key === _vm.selected
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(" " + _vm.$t(item.descTip))
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                                _c("i", {
                                  class: `${item.icon}_hover`,
                                  staticStyle: { display: "none" },
                                }),
                                _c("div", { staticClass: "anchor-point" }),
                              ]
                            ),
                          ]
                        )
                      : [
                          _c("i", {
                            staticClass: "icon",
                            class: `${item.icon}${
                              item.key === _vm.selected ? "_hover" : ""
                            } ${
                              item.descTip && item.key === _vm.selected
                                ? "icon-desc-tip"
                                : ""
                            }`,
                          }),
                          _c(
                            "p",
                            {
                              staticClass: "name",
                              attrs: { title: _vm.$t(item.label) },
                            },
                            [_vm._v(_vm._s(_vm.$t(item.label)))]
                          ),
                          _c(
                            "p",
                            {
                              staticClass: "desc",
                              attrs: {
                                title:
                                  _vm.$t(item.desc) +
                                  " " +
                                  _vm.$t(item.descTip),
                              },
                            },
                            [
                              _c("span", [_vm._v(_vm._s(_vm.$t(item.desc)))]),
                              item.descTip && item.key === _vm.selected
                                ? _c("span", [
                                    _vm._v(_vm._s(" " + _vm.$t(item.descTip))),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                          _c("i", {
                            class: `${item.icon}_hover`,
                            staticStyle: { display: "none" },
                          }),
                          _c("div", { staticClass: "anchor-point" }),
                        ],
                  ],
                  2
                )
              }),
              0
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "dialog-footer" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.confirmBtnLoad,
                    expression: "confirmBtnLoad",
                  },
                ],
                staticClass: "dialog-btn-primary",
                attrs: {
                  type: "primary",
                  title: _vm.$t("confirm"),
                  disabled: _vm.confirmBtnLoad,
                },
                on: { click: _vm.confirmType },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("confirm")) + "\n      ")]
            ),
            _c(
              "el-button",
              {
                staticClass: "dialog-btn-cancel",
                attrs: { title: _vm.$t("cancel") },
                on: {
                  click: function ($event) {
                    _vm.show = false
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("cancel")) + "\n      ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }